import { ItemComponentType } from "../components/Inventory/AddEditComponent/componentType";
import api from "./api";
export type DeleteItemComponentDto = {
  id: number | string;
};

/*Item Component search filter */

export const getItemComponentApi = async (body: {
  itemid: string | number | undefined;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/items/${body.itemid}/components?q=${body.q.toString()}`;
  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }
  return await api.get(url);
};

/*Item Component main */

export const getItemComponent = async (itemid: string | number | undefined) => {
  return await api.get(`/items/${itemid}/components`);
};

/*delete item component */

export const deleteItemComponent = async (dto: DeleteItemComponentDto) => {
  return await api.delete(`/items/components/${dto.id}`);
};

/*create item component */

export const createItemComponent = async (
  itemComponentDetails: ItemComponentType
) => {
  return await api.post("/items/components", itemComponentDetails);
};
